import React from 'react';

import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import appContent from '@/services/content/appContent.typed';
import type {AutoDeliveryDeliveryAddress} from '@/types/icc/autoDeliveryDetails';

import AutoDeliveryDcxSection from './AutoDeliveryDcxSection';
import AutoDeliveryDcxSectionButton from './AutoDeliveryDcxSectionButton';

interface AutoDeliveryDcxOrderAddressProps {
    className?: string;
    address: AutoDeliveryDeliveryAddress | null;
    isEditAllowed?: boolean;
    isUpdateDisabled?: boolean;
}

const AutoDeliveryDcxOrderAddress = ({
    className,
    address,
    isEditAllowed,
    isUpdateDisabled,
}: AutoDeliveryDcxOrderAddressProps) => {
    const content = appContent.getAutoDeliveryContent()?.extendedDetailsContent;

    if (!address || !content) return null;

    const {deliveryAddressTitle, deliveryAddressUpdateButton, deliveryAddressIcon} = content;
    const {formattedAddress} = address;

    return (
        <AutoDeliveryDcxSection
            className={className}
            title={deliveryAddressTitle}
            action={
                isEditAllowed ? (
                    <AutoDeliveryDcxSectionButton button={deliveryAddressUpdateButton} disabled={isUpdateDisabled} />
                ) : undefined
            }
        >
            <div className='mt-4 flex items-start gap-2'>
                <RemoteIconV2 icon={deliveryAddressIcon} className='shrink-0' />
                {formattedAddress && (
                    <div>
                        <p className='text-16 leading-155 tracking-02'>{formattedAddress}</p>
                    </div>
                )}
            </div>
        </AutoDeliveryDcxSection>
    );
};

export default AutoDeliveryDcxOrderAddress;
